import * as Location from "expo-location";

export type Coords = { latitude: number; longitude: number };

export const DEFAULT_POSITION_TIMEOUT_MS = 3000;

export const requestCurrentPositionWithTimeout = async (
  timeoutMs: number = DEFAULT_POSITION_TIMEOUT_MS,
): Promise<Coords | null> => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeoutPromise = new Promise<null>((resolve) => {
    timer = setTimeout(() => resolve(null), timeoutMs);
  });
  const positionPromise = Location.getCurrentPositionAsync({})
    .then(
      (location): Coords => ({
        latitude: location.coords.latitude,
        longitude: location.coords.longitude,
      }),
    )
    .catch(() => null);

  try {
    return await Promise.race([positionPromise, timeoutPromise]);
  } finally {
    if (timer) clearTimeout(timer);
  }
};
